interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  tone?: "dark" | "light";
  as?: "h2" | "h3";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  tone = "dark",
  as = "h2",
}: SectionHeadingProps) {
  const alignment = align === "center" ? "text-center items-center mx-auto" : "text-left items-start";
  const titleColor = tone === "light" ? "text-background-50" : "text-foreground-950";
  const descColor = tone === "light" ? "text-background-200" : "text-foreground-600";

  const HeadingTag = as;

  return (
    <div className={`flex flex-col max-w-2xl ${alignment}`}>
      {eyebrow ? (
        <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 font-label text-xs font-semibold uppercase tracking-wider text-accent-800">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true"></span>
          {eyebrow}
        </span>
      ) : null}
      <HeadingTag className={`font-heading text-2xl font-semibold leading-tight md:text-4xl ${titleColor}`}>
        {title}
      </HeadingTag>
      {description ? (
        <p className={`mt-4 font-body text-sm leading-relaxed md:text-base ${descColor}`}>{description}</p>
      ) : null}
    </div>
  );
}